import { useToast } from '@barfacil/barfacil-ui'
import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { useState } from 'react'

import {
  CategoryOptionsResponse,
  CreatePriceListProductBody,
  PriceListProductsResponse,
} from '@/api/_schemas/management'
import { createPriceListProduct } from '@/api/management'
import { FormCreatePriceList } from '@/app/panel/management/price-list/_schemas/create-price-list'
import { ApiError } from '@/config/api'
import { keyStore } from '@/config/key-store'
import { queryClient } from '@/config/query-client'
import { FormError, handleErrors } from '@/services/fetch'

export const useCreatePriceListProduct = () => {
  const [formErrors, setFormErrors] = useState<FormError[]>([])

  const { toastDestructive, toastPositive } = useToast()

  const mutation = useMutation({
    mutationFn: async (data: CreatePriceListProductBody & { id: number }) =>
      await createPriceListProduct(data, { id: data.id }),
    onSuccess: (data, { id }) => {
      queryClient.setQueryData<PriceListProductsResponse>(
        [...keyStore.priceList.products.queryKey, id],
        (oldData) => oldData && [data as never, ...oldData],
      )

      queryClient.setQueryData<CategoryOptionsResponse>(
        [...keyStore.priceList.categoryOptions.queryKey],
        (oldData) => {
          const categories = oldData ?? []
          const { produto_pai: newCategory } = data.produto

          return newCategory &&
            !categories.some(
              ({ cod_produto: id }) => id === newCategory.cod_produto,
            )
            ? [...categories, newCategory]
            : oldData
        },
      )

      queryClient.refetchQueries({
        queryKey: [...keyStore.priceList.productOptions.queryKey],
        exact: false,
      })

      setFormErrors([])
      toastPositive('Produto adicionado na lista de preços!')
    },
    onError: ({ response }: AxiosError<ApiError>, data) => {
      setFormErrors(
        handleErrors<FormCreatePriceList>(
          response?.data,
          Object.keys(data) as (keyof FormCreatePriceList)[],
          toastDestructive,
        ),
      )
    },
  })

  return { mutation, formErrors }
}
